import api from '@/services/api';

export interface ApiUserNotification {
  id: number;
  type: 'success' | 'warning' | 'error' | 'info';
  title: string;
  message: string;
  read: boolean;
  created_at: string;
}

export interface NotificationsListResponse {
  items: ApiUserNotification[];
  unread_count: number;
  total: number;
}

export async function fetchUserNotifications(): Promise<NotificationsListResponse> {
  const response = await api.get<NotificationsListResponse>('/users/me/notifications');
  return response.data;
}

export async function markNotificationRead(id: number): Promise<void> {
  await api.patch(`/users/me/notifications/${id}/read`);
}

export async function markAllNotificationsRead(): Promise<void> {
  await api.patch('/users/me/notifications/mark-all-read');
}

export async function deleteNotification(id: number): Promise<void> {
  await api.delete(`/users/me/notifications/${id}`);
}

export async function clearAllNotifications(): Promise<void> {
  await api.delete('/users/me/notifications');
}
